import { useState } from "react";

export const useRFQQuoteSubmission = () => {
  const [formData, setFormData] = useState<Record<string, any>>({
    expiryDate: undefined,
  });
  const [filesMap, setFilesMap] = useState<Record<string, File[]>>({});

  const handleChange = (key: string, value: any) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return { formData, filesMap, setFilesMap, handleChange };
};
